import { Map } from 'immutable';
import defaultDialogReducer from '../../defaultDialogReducer';
import {dialogsNames} from '../../../enums/dialogsNames';
import { actionTypes as actionTypes } from '../../../actions/Dialogs/ImportFilesJsonDialog/importFilesJsonDialogActions';

let defaultState = {
  loading: false,
  show: false,
  importType: '',
};

export default function(state = Map(defaultState), action) {
  switch (action.type) {
    case actionTypes.IMPORT_FILES_JSON_DIALOG_SHOW:
      state = state.set('importType', action.payload?.importType ?? '');
      return state.set('show', true);

    default:
      return defaultDialogReducer(state, action, dialogsNames.IMPORT_FILES_JSON_DIALOG, defaultState);
  }
}












